import * as CONST from "./actionTypes";

export const signUp = (payload, callBack) => {
  return {
    type: CONST.SIGN_UP,
    payload,
    callBack,
  };
};


export const logIn = (payload, callBack) => {
  return {
    type: CONST.LOGIN,
    payload,
    callBack,
  };
};


export const logInSuccess = (payload, callBack) => {
  return {
    type: CONST.LOGIN_SUCCESS,
    payload,
    callBack,
  };
};

export const logInFail = (payload, callBack) => {
  return {
    type: CONST.LOGIN_FAIL,
    payload,
    callBack,
  };
};

export const logout = (payload) => {
  console.log(payload , "payload")
  return {
    type: CONST.LOG_OUT,
    payload,
    
  };
};



